var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-card',{staticClass:"app-main",style:('min-height:' + _vm.contentHeight)},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }